import { cn } from "@/utils/cn";
import { memo } from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

export const Toggle = memo(function Toggle({
  checked,
  onChange,
  disabled = false,
  className,
  "aria-label": ariaLabel,
}: ToggleProps) {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!disabled && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={cn(
        "relative inline-flex h-[28px] w-[64px] items-center rounded-full",
        "bg-toggle-switch-off transition-colors duration-200 ease-in-out",
        "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-toggle-switch-off",
        {
          "opacity-50 cursor-not-allowed": disabled,
          "bg-os-brand": checked,
        },
        className,
      )}
    >
      <span
        className={cn(
          "inline-block h-[24px] w-[39px] transform rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out",
          {
            "translate-x-[22px]": checked,
            "translate-x-[2px]": !checked,
          },
        )}
      />
    </button>
  );
});

export default Toggle;
